module.exports = {
    // basic
    'last-password-change-date': 'last password change date',
    'last-login-date': 'last login date',
    'role-type': 'role type',
    'role-types': 'role types',
    'login-count': 'login count',
    // raw
    'well-users-company-help': `View activity of all users from this company on this well.`,
    'well-users-email-help': `Email this user.`,
    'well-users-username-help': `View activity of this user on this well.`,

    // template
};
